// In the corrected results endpoint, we get `fields` and `results`. This function will transform the
// results into an array, similar to the `fields` array, so that we can easily iterate over both arrays
import { IFieldReview } from '../components/review/form/FieldList';
import { IExtractionResults } from '../types/my-types';

export const transformResultsToFields = (results: IExtractionResults): IFieldReview[] => {
  return results
    ? Object.entries(results)
        .reduce<IFieldReview[]>((acc, [label, result]) => {
          if (typeof result === 'object' && result !== null) {
            acc.push({
              ...result,
              label: label,
            } as IFieldReview);
          }
          return acc;
        }, [])
        .sort((a, b) => (a.field_order ?? 0) - (b.field_order ?? 0))
    : [];
};
